import React, { useState } from "react";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import {
  MdPhone,
  MdEmail,
  MdGavel,
  MdShield,
  MdPeople,
  MdAccessTime,
  MdCalendarToday,
} from "react-icons/md";
import logo from "../assets/images/logo/logo.png";

const COLORS = {
  bgTop: "#6B1212",
  bgMain: "#7A1414",
  bgSub: "#6B1212",
  bgMobile: "#550F0F",
  bgDropdown: "#5A0E0E",
  bgSubMenu: "#3D0A0A",
  gold: "#C6A75E",
  goldDark: "#A8893D",
  cream: "#F5ECD7",
  textLight: "#F2E4C8",
  textMuted: "rgba(245,236,215,0.65)",
  borderGold: "rgba(198,167,94,0.25)",
};

const navLinks = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about-us" },
 {
  name: "Practice Areas",
  href: "/services", // Parent page link
  isDropdown: true,
  subLinks: [
    { name: "Criminal Cases", href: "/services/criminal-cases" },
    { name: "Civil Cases", href: "/services/civil-cases" },
    { name: "Matrimonial Cases", href: "/services/matrimonial-cases" },
    { name: "Immigration Law", href: "/services/immigration-law" },
    { name: "Company Related", href: "/services/company-related-issue" },
    { name: "Commercial Disputes", href: "/services/commercial-disputes" },
    { name: "Cyber Crime", href: "/services/cyber-cases" },
    { name: "Labor Law", href: "/services/labor-law" },
    {
      name: "Negotiable Instrument Act Cases",
      href: "/services/negotiable-instrument-act-cases",
    },
    { name: "IPR", href: "/services/intellectual-property-rights" },
    { name: "Copyright & Trademark", href: "/services/copyright-trademark" },
    {
      name: "Real Estate",
      href: "/services/real-estate-regulatory-authority",
    },
  ],
},
{ name: "Team", href: "/team" },
 { name: "Careers", href: "/careers" },
  { name: "Blog", href: "/blogs" },
  { name: "Contact", href: "/contact-us" },
];

const NavLink = ({ children, href, style = {}, className = "" }) => (
  <a
    href={href}
    className={`group relative uppercase py-1 transition-colors duration-300 ${className}`}
    style={{
      fontFamily: "'Cinzel', serif",
      fontSize: "11px",
      letterSpacing: "0.18em",
      color: COLORS.cream,
      textDecoration: "none",
      ...style,
    }}
    onMouseOver={(e) => (e.currentTarget.style.color = COLORS.gold)}
    onMouseOut={(e) => (e.currentTarget.style.color = COLORS.cream)}
  >
    {children}

    <span
      className="absolute bottom-0 left-0 w-0 group-hover:w-full transition-all duration-300"
      style={{
        height: "1px",
        background: COLORS.gold,
      }}
    />
  </a>
);

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileSubOpen, setIsMobileSubOpen] = useState(false);

  return (
    <header className=" top-0 left-0 w-full z-50 shadow-lg">
      {/* ── Main nav bar ── */}
      <div
        style={{
          backgroundColor: COLORS.bgMain,
          borderBottom: `2px solid ${COLORS.gold}`,
        }}
        className="px-6 lg:px-10"
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-4 py-2 group">
            <div className="relative">
              <img
                src={logo}
                alt="R & P Law Partners"
                className="
        h-14
        md:h-16
        w-auto
        object-contain
        transition-transform
        duration-500
        group-hover:scale-105
      "
              />
            </div>

            <div className="hidden sm:block">
              <h2
                style={{
                  fontFamily: "'Cinzel', serif",
                  color: COLORS.cream,
                }}
                className="text-xl lg:text-2xl font-semibold tracking-[0.15em]"
              >
                R & P
              </h2>

              <div className="flex items-center gap-2 mt-1">
                <div
                  className="w-6 h-[1px]"
                  style={{ backgroundColor: COLORS.gold }}
                />

                <span
                  style={{
                    color: COLORS.gold,
                    fontFamily: "'Cormorant Garamond', serif'",
                  }}
                  className="uppercase tracking-[0.35em] text-[10px]"
                >
                  Law Partners
                </span>

                <div
                  className="w-6 h-[1px]"
                  style={{ backgroundColor: COLORS.gold }}
                />
              </div>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden xl:flex items-center gap-7 h-16">
           {navLinks.map((link) =>
  link.isDropdown ? (
    <div
      key={link.name}
      className="relative h-full flex items-center"
      onMouseEnter={() => setIsDropdownOpen(true)}
      onMouseLeave={() => setIsDropdownOpen(false)}
    >
      <a
        href={link.href}
        className="flex items-center gap-1 uppercase transition-colors duration-300"
        style={{
          fontFamily: "'Cinzel', serif",
          fontSize: "11px",
          letterSpacing: "0.18em",
          color: isDropdownOpen ? COLORS.gold : COLORS.cream,
          textDecoration: "none",
          cursor: "pointer",
        }}
      >
        {link.name}
        <FaChevronDown
          size={10}
          style={{
            transform: isDropdownOpen ? "rotate(180deg)" : "",
            transition: "transform 0.3s",
          }}
        />
      </a>

      {isDropdownOpen && (
        <div
          className="absolute top-full left-0 w-72 py-2 z-50"
          style={{
            backgroundColor: COLORS.bgDropdown,
            borderTop: `2px solid ${COLORS.gold}`,
            border: `0.5px solid ${COLORS.borderGold}`,
            borderTopColor: COLORS.gold,
          }}
        >
          {link.subLinks.map((sub) => (
            <a
              key={sub.name}
              href={sub.href}
              className="block px-5 py-2.5 text-sm transition-all duration-200"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: "14px",
                letterSpacing: "0.05em",
                color: COLORS.textLight,
                borderLeft: "2px solid transparent",
                textDecoration: "none",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.color = COLORS.gold;
                e.currentTarget.style.borderLeftColor = COLORS.gold;
                e.currentTarget.style.background =
                  "rgba(198,167,94,0.08)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.color = COLORS.textLight;
                e.currentTarget.style.borderLeftColor = "transparent";
                e.currentTarget.style.background = "transparent";
              }}
            >
              {sub.name}
            </a>
          ))}
        </div>
      )}
    </div>
  ) : (
    <NavLink key={link.name} href={link.href}>
      {link.name}
    </NavLink>
  )
)}
          </nav>

          {/* Hamburger */}
          <button
            className="xl:hidden focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
            style={{
              color: COLORS.cream,
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            {isOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
        </div>
      </div>

      {/* ── Trust bar ── */}
      <div
        className="hidden lg:flex items-center justify-between px-10"
        style={{
          backgroundColor: COLORS.bgSub,
          borderBottom: `0.5px solid ${COLORS.borderGold}`,
          height: "44px",
        }}
      >
        <div className="flex items-center gap-5">
          {[
            { icon: <MdGavel size={14} />, text: "1000+ Cases Won" },
            { icon: <MdPeople size={14} />, text: "15+ Years of Excellence" },
          ].map((item, i) => (
            <React.Fragment key={item.text}>
              {i > 0 && (
                <div
                  style={{
                    width: "1px",
                    height: "18px",
                    background: COLORS.borderGold,
                  }}
                />
              )}
              <span
                className="flex items-center gap-1.5"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "13px",
                  color: COLORS.textMuted,
                  letterSpacing: "0.06em",
                }}
              >
                <span style={{ color: COLORS.gold }}>{item.icon}</span>
                {item.text}
              </span>
            </React.Fragment>
          ))}
        </div>
        <span
          className="flex items-center gap-1.5"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "12px",
            color: COLORS.gold,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
          }}
        >
          <MdAccessTime size={13} /> Mon–Sat: 9am–10pm
        </span>
      </div>

      {/* ── Mobile menu ── */}
      {isOpen && (
        <div
          className="xl:hidden h-screen overflow-y-auto"
          style={{
            backgroundColor: COLORS.bgMobile,
            borderTop: `0.5px solid ${COLORS.borderGold}`,
          }}
        >
          <div className="px-6 py-5 space-y-1">
            {navLinks.map((link) =>
              link.isDropdown ? (
                <div key={link.name}>
                  <button
                    type="button"
                    onClick={() => setIsMobileSubOpen(!isMobileSubOpen)}
                    className="w-full flex justify-between items-center py-3.5 border-b"
                    style={{
                      fontFamily: "'Cinzel', serif",
                      fontSize: "12px",
                      letterSpacing: "0.15em",
                      textTransform: "uppercase",
                      color: COLORS.cream,
                      borderColor: COLORS.borderGold,
                      background: "none",
                      border: "none",
                      borderBottom: `0.5px solid ${COLORS.borderGold}`,
                      cursor: "pointer",
                    }}
                  >
                    {link.name}
                    <FaChevronDown
                      size={12}
                      style={{
                        color: COLORS.gold,
                        transform: isMobileSubOpen ? "rotate(180deg)" : "",
                        transition: "transform 0.3s",
                      }}
                    />
                  </button>
                  {isMobileSubOpen && (
                    <div
                      className="ml-4 my-2 py-2"
                      style={{
                        backgroundColor: COLORS.bgSubMenu,
                        borderLeft: `2px solid ${COLORS.gold}`,
                      }}
                    >
                      {link.subLinks.map((sub) => (
                        <a
                          key={sub.name}
                          href={sub.href}
                          className="block py-2.5 px-4 transition-colors duration-200"
                          style={{
                            fontFamily: "'Cormorant Garamond', serif",
                            fontSize: "14px",
                            color: COLORS.textLight,
                            textDecoration: "none",
                            letterSpacing: "0.05em",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.color = COLORS.gold)
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.color = COLORS.textLight)
                          }
                        >
                          {sub.name}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  href={link.href}
                  className="block py-3.5"
                  style={{
                    fontFamily: "'Cinzel', serif",
                    fontSize: "12px",
                    letterSpacing: "0.15em",
                    textTransform: "uppercase",
                    color: COLORS.cream,
                    textDecoration: "none",
                    borderBottom: `0.5px solid ${COLORS.borderGold}`,
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.color = COLORS.gold)
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.color = COLORS.cream)
                  }
                >
                  {link.name}
                </a>
              ),
            )}

            <a
              href="/contact-us"
              className="flex items-center justify-center gap-2 w-full mt-4 py-3.5 transition-all duration-300"
              style={{
                fontFamily: "'Cinzel', serif",
                fontSize: "11px",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                backgroundColor: COLORS.gold,
                color: "#3B0A0A",
                textDecoration: "none",
              }}
            >
              <MdCalendarToday size={15} />
              Schedule Consultation
            </a>

            <div className="pt-4 flex gap-5">
              <span
                className="flex items-center gap-1.5"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "13px",
                  color: COLORS.textMuted,
                }}
              >
                <MdPhone size={13} style={{ color: COLORS.gold }} /> +91 9661900233
              </span>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
